module.exports = __webpack_public_path__ + "static/media/memoriesText.6c7b5ec0.png";